import { createFileRoute } from "@tanstack/react-router";

import { routeHead } from "@/lib/seo-head";
import AmenagementProfessionnel from "@/pages/AmenagementProfessionnel";

export const Route = createFileRoute("/amenagement-professionnel-hotellerie")({
  head: () =>
    routeHead({
      path: '/amenagement-professionnel-hotellerie',
      title: 'Aménagement professionnel & hôtellerie Lyon | JIIA Studio',
      description: "Architecte d'intérieur pour hôtels, restaurants, bureaux et commerces à Lyon : conception, images 3D, normes PMR et suivi de chantier.",
    }),
  component: AmenagementProfessionnel,
});
